import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { isToday } from 'date-fns';
import { deliveryDetailsMessages } from './confirmationMessages';
import { FormatMessage } from '../core';
export const RequestedDelivery = ({ requestedDelivery, isSelfBuy }) => {
    const displayToday = isSelfBuy || isToday(requestedDelivery);
    return displayToday ? (
        <FormattedMessage {...deliveryDetailsMessages.deliveryToday} />
    ) : (
        <FormattedDate value={requestedDelivery} year="numeric" month="long" day="2-digit" timeZoneName="short" />
    );
};

RequestedDelivery.propTypes = {
    requestedDelivery: PropTypes.instanceOf(Date).isRequired,
    isSelfBuy: PropTypes.bool.isRequired
};

export const DigitalDeliveryDetails = ({ recipientEmail, confirmationEmail, isSelfBuy }) => (
    <div className="digital-delivery-details">
        <div className="item-confirmation-summary-line">
            <FormatMessage
                intlMessage={deliveryDetailsMessages.emailLabel}
                className="item-confirmation-summary-label"
            />
            <FormatMessage
                intlMessage={deliveryDetailsMessages.deliveryEmail}
                values={{ isSelfBuy: isSelfBuy.toString(), recipientEmail, confirmationEmail }}
            />
        </div>
    </div>
);

DigitalDeliveryDetails.defaultProps = {
    recipientEmail: '',
    confirmationEmail: '',
    isSelfBuy: false
};
DigitalDeliveryDetails.propTypes = {
    recipientEmail: PropTypes.string,
    confirmationEmail: PropTypes.string,
    isSelfBuy: PropTypes.bool
};

/**
 * Physical delivery details component intended for line item components.
 */
export const PhysicalDeliveryDetails = ({ city, state, postalCode, shippingMethod }) => (
    <React.Fragment>
        <div>
            <b>
                <FormattedMessage {...deliveryDetailsMessages.shipToLabel} />
            </b>
            {` ${city}, ${state} ${postalCode}`}
        </div>
        <div>{shippingMethod}</div>
    </React.Fragment>
);

PhysicalDeliveryDetails.propTypes = {
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    shippingMethod: PropTypes.string
};

PhysicalDeliveryDetails.defaultProps = {
    city: '',
    state: '',
    postalCode: '',
    shippingMethod: '',
};

/**
 * Returns digital or physical delivery details depending on line item delivery method.
 */
export const DeliveryDetails = ({
    isSelfBuy,
    recipientEmail,
    confirmationEmail,
    deliveryMethod,
    shipTo,
    shippingMethod
}) =>
    deliveryMethod === 'DIGITAL' ? (
        <DigitalDeliveryDetails {...{ recipientEmail, confirmationEmail, isSelfBuy }} />
    ) : (
        <PhysicalDeliveryDetails {...{ ...shipTo, shippingMethod }} />
    );

DeliveryDetails.defaultProps = {
    recipientEmail: '',
    confirmationEmail: '',
    deliveryDate: new Date(),
    isSelfBuy: false,
    shipTo: {},
    shippingMethod: ''
};
DeliveryDetails.propTypes = {
    isSelfBuy: PropTypes.bool,
    recipientEmail: PropTypes.string,
    confirmationEmail: PropTypes.string,
    deliveryDate: PropTypes.instanceOf(Date),
    deliveryMethod: PropTypes.oneOf(['DIGITAL', 'PHYSICAL']).isRequired,
    shipTo: PropTypes.object,
    shippingMethod: PropTypes.string
};
